import React, {  } from 'react';

import { numberFormatOptions } from '../types';
import { IntlFunction } from './Intl.Function';
import { NumberFormatRuleSet } from './Intl.NumberFormat';

export const IntlNumberFormatResolvedOptions = () => (
	<IntlFunction
		input={[]}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/resolvedOptions"
		header="Intl.NumberFormat.prototype.resolvedOptions"
		description="Returns a new object with properties reflecting the locale and number formatting options computed during initialization of this [Intl.NumberFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat) object."
		options={numberFormatOptions}
		ruleSet={NumberFormatRuleSet}
		template="new Intl.NumberFormat(##locale##, ##options##).resolvedOptions()" />
)